const Settings = {
    API_URL: `${process.env.GATSBY_API_URL}/umbraco`
}

export default Settings;